"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Collapsed = require("../../../../../ui/Collapsed");
var _styles = _interopRequireDefault(require("./styles"));
var _clearIcon = _interopRequireDefault(require("./clearIcon.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var renderCollapsedTriggerContent = function renderCollapsedTriggerContent(_ref) {
  var isFilterActive = _ref.isFilterActive,
    title = _ref.title,
    t = _ref.t;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default['filter-title-wrapper']
  }, /*#__PURE__*/_react.default.createElement("h5", {
    className: _styles.default['filter-title']
  }, title), isFilterActive && /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default['filter-clear-btn']
  }, t('RESET_FILTER_BUTTON'), /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default['filter-clear-btn__icon'],
    dangerouslySetInnerHTML: {
      __html: _clearIcon.default
    }
  })));
};
var FilterCollapsed = function FilterCollapsed(_ref2) {
  var _ref2$arrow = _ref2.arrow,
    arrow = _ref2$arrow === void 0 ? true : _ref2$arrow,
    disabled = _ref2.disabled,
    className = _ref2.className,
    children = _ref2.children,
    contentClassName = _ref2.contentClassName,
    _ref2$initialOpen = _ref2.initialOpen,
    initialOpen = _ref2$initialOpen === void 0 ? false : _ref2$initialOpen,
    isActive = _ref2.isActive,
    title = _ref2.title,
    triggerBtnClassName = _ref2.triggerBtnClassName,
    onReset = _ref2.onReset;
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULT_CARD'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_Collapsed.Collapsed, {
    arrow: arrow && !isActive,
    className: (0, _classnames.default)(_styles.default.filter, className),
    contentClassName: contentClassName,
    disabled: disabled,
    initialOpen: initialOpen,
    title: renderCollapsedTriggerContent({
      isFilterActive: isActive,
      title: title,
      t: t
    }),
    triggerBtnClassName: (0, _classnames.default)(_styles.default['filter-title__btn'], triggerBtnClassName),
    onClose: isActive ? onReset : undefined
  }, children);
};
FilterCollapsed.propTypes = {
  arrow: _propTypes.default.bool,
  className: _propTypes.default.string,
  contentClassName: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  initialOpen: _propTypes.default.bool,
  isActive: _propTypes.default.bool.isRequired,
  title: _propTypes.default.string.isRequired,
  onReset: _propTypes.default.func
};
var _default = exports.default = FilterCollapsed;